import { render, staticRenderFns } from "./DashboardSatisfaction.vue?vue&type=template&id=71eb27ac&"
import script from "./DashboardSatisfaction.vue?vue&type=script&lang=js&"
export * from "./DashboardSatisfaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports